// 🔒
export const faqs = [
  {
    id: 1,
    question: "How does the app work?",
    answer:
      "The app gives users access to structured fitness programs, trainer-led content, workout guidance, and a premium mobile experience designed to make training easier to follow and more motivating."
  },
  {
    id: 2,
    question: "Is the app suitable for beginners?",
    answer:
      "Yes. The platform can include beginner-friendly programs as well as more advanced options, so users can choose training that matches their current level and goals."
  },
  {
    id: 3,
    question: "Do I need gym experience before starting?",
    answer:
      "No. Many programs can be designed for people who are just getting started, while others can support more experienced users who want structure and progression."
  },
  {
    id: 4,
    question: "Can I browse different trainers in the app?",
    answer:
      "Yes. Users can explore trainers, view their programs, and choose the coaching style or training approach that fits them best."
  },
  {
    id: 5,
    question: "How do I buy a program?",
    answer:
      "Programs can be purchased directly through the app experience. Once unlocked, users can access their content more easily and keep everything organized in one place."
  },
  {
    id: 6,
    question: "Can trainers join the platform?",
    answer:
      "Yes. Trainers can collaborate with the platform, publish their content in a premium format, and reach more users through the app."
  },
  {
    id: 7,
    question: "What do trainers need to prepare?",
    answer:
      "Trainers mainly prepare their coaching content and program structure. The platform team can handle implementation, presentation, and the in-app experience."
  },
  {
    id: 8,
    question: "How do trainers earn through the app?",
    answer:
      "Trainers can earn revenue from their published programs. If you want precise business terms, you can provide those details on the trainer collaboration page or in direct communication."
  },
  {
    id: 9,
    question: "Is the app available on iPhone and Android?",
    answer:
      "Yes. The landing page can link users directly to the App Store and Google Play so they can download the app on their preferred device."
  },
  {
    id: 10,
    question: "How can I get support or ask more questions?",
    answer:
      "Users can contact you through your preferred support channel, and trainers can use the collaboration form to get in touch about joining the platform."
  }
];
// 🔒